export const EVENT_HEADER = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.EventHeaderWidgetElement';
